"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataLevel = void 0;
class DataLevel {
}
exports.DataLevel = DataLevel;
//# sourceMappingURL=data-level.js.map